module.exports = __webpack_public_path__ + "assets/code.ec69c047.svg";